<template>
  <el-dialog custom-class="list-dialog" title="选择商品" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-row>
      <el-col :span="4" v-if="showCat">
        <div class="grid-content bg-purple treeContent">
          <CommonTreeView
            ref="treeSeed" :defineDataSource="true" @bindData="bindData"
            :onlyShowGroupType="true"
            @check="checktree1"
            :needTopNode="false"></CommonTreeView>
        </div>
      </el-col>
      <el-col :span="showCat?20:24">
        <div class="grid-content bg-purple-light">
          <!--<div>-->
          <div class="search-content">
            <el-col :span="24" class="toobar">
              <el-input style="width:200px;"
                        placeholder="请输入名称、编码"
                        prefix-icon="el-icon-search"
                        v-model="searchdata">
              </el-input>
              <el-select v-model="filltemplate" placeholder="下单方式" style="width:110px">
                <el-option key="" label="下单方式" value="">
                </el-option>
                <el-option
                  v-for="item in ftype"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
              <!--<el-select v-model="nostock" placeholder="仓库存储" style="width:110px">-->
                <!--<el-option key="" label="仓库存储" value="">-->
                <!--</el-option>-->
                <!--<el-option key="1" label="备货" value="1">-->
                <!--</el-option>-->
                <!--<el-option key="-1" label="不备货" value="-1">-->
                <!--</el-option>-->
              <!--</el-select>-->
              <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid()">搜索
              </el-button>
              <el-button type="warning" v-on:click="SelectOK" v-if="isShowCheckBox">确定选择</el-button>
            </el-col>
          </div>
          <el-table :data="tableData" :height="tableHeight(151)" ref="table1"
                    size="mini" stripe border style="width: 100%;" @selection-change="handleSelectionChange">
            <el-table-column
              width="60"
              label="序号"
              align="center">
              <template slot-scope="scope">
                {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
              </template>
            </el-table-column>
            <el-table-column
              prop="codeandname"
              label="名称"
              align="left"
              header-align="center">
              <template slot-scope="scope">
                <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 100%;height:24px;"
                     :title="scope.row.seedname">
                  {{scope.row.seedname}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="seedcode"
              label="编码"
              align="left"
              header-align="center"
              width="150">
            </el-table-column>
            <el-table-column
              prop="categoryname"
              label="品牌"
              align="left"
              header-align="center"
              width="200">
            </el-table-column>
            <el-table-column v-if="isShowCheckBox"
                             type="selection" align="right"
                             width="70">
            </el-table-column>
            <el-table-column v-if="!isShowCheckBox"
                             label="操作"
                             align="center" width="80">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="warning"
                  @click="handleSel(scope.$index, scope.row)">选择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="foot">
            <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
          </div>
        </div>
        <!--</div>-->
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
  import {getListfixcilumn, getGoodsTree} from '@/api/set/jxcgooddetail'

  export default {
    name: 'JxcgooddetailSel',
    data() {
      return {
        SelectionChange: [],
        filltemplate: "",
        nostock: "",
        dialogFormVisible: false,
        searchdata: "",
        otherparam:{},
        loading: true,
        guids: '',
        pagination: {
          currentPage: 1,
          pageSize: 50,
          total: 0
        },
        ftype: [
          {
            value: '80',
            name: "镜架"
          },
          {
            value: '10',
            name: "现片"
          },
          {
            value: '30',
            name: "区分左右眼"
          },
          {
            value: '20',
            name: "定制"
          },
          {
            value: '50',
            name: "加工"
          },
          {
            value: '60',
            name: "特殊加工"
          },
          {
            value: '40',
            name: "数量选择"
          },
        ],
        tableData: [],
      }
    },
    props: {
      isShowCheckBox: {//true表示多选
        default: false
      },
      showCat:{
        default:true
      }
    },
    methods: {
      checktree1(guids, names, arr) {
        this.pagination.currentPage = 1;
        this.guids = guids;
        this.bindGrid();
      },
      show(otherparam) {
        this.otherparam = otherparam;
        if (this.isShowCheckBox && this.$refs.table1) {
          this.$refs.table1.clearSelection()
        }
        this.dialogFormVisible = true
        //this.bindGrid()
      },
      bindGrid() {
        var searchParam={
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          searchdata: this.searchdata,
          categorycode: this.guids,
          filltemplate: this.filltemplate,
          nostock: this.nostock
        };
        if(this.otherparam){
          for(let key in this.otherparam){
            searchParam[key]=this.otherparam[key]
          }
        }
        getListfixcilumn(searchParam).then(response => {
          var lenframe= response.data.lenframe
          this.tableData = response.data.obj.rows
          if(lenframe) {
            for (let j in lenframe) {
              for (let i in this.tableData) {
                if (lenframe[j].seedcode == this.tableData[i].seedcode) {
                  this.tableData[i].framecolor=lenframe[j].color;
                  break;
                }
              }
            }
          }
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        });
      },
      handleSel(index, row) {//单选
        this.$emit("afterSelectCode", row)
        this.dialogFormVisible = false
      },
      SelectOK() {//多选
        this.$emit("afterSelectCode", this.SelectionChange)
        this.dialogFormVisible = false;
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType: true, onlyShowEnabledGroupType: true})
        })
      },
      handleSelectionChange(val) {
        this.SelectionChange = val;
      }
    },
    mounted() {
    },
    components: {}

  }
</script>


<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/set/jxcgooddetail/JxcgooddetailSel.vue